import styled from "styled-components";
import { setPosition, setFlex, preventDrag } from "../variables/utils";
import { BREAKPOINTS, hiddenmd, ipad } from "../variables/breakpoints";
import { COLOURS } from "../variables/colours";
import { setCursor } from "../variables/cursors";

export const LoadingWrapper = styled.div`
  ${setPosition({ position: "absolute", top: "0", left: "0", zIndex: 999 })};
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  ${preventDrag()};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ justify: "flex-end", align: "flex-start" })};
    height: 100lvh;
  }
`;

export const LoadingContainer = styled.div`
  ${setFlex({ direction: "column", align: "center", justify: "space-around" })};
  margin: 2rem;
  height: 100%;
  width: -webkit-fill-available;
  @media (max-width: ${BREAKPOINTS.md}px) {
    max-height: ${props => (props.$isHSWeb ? "85svh" : "100vh")};
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-height: ${props => (props.$isHSWeb ? "65vh" : "90svh")};
  }
`;

export const LoadingContent = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "row", align: "center" })};
  height: 100%;
  width: -webkit-fill-available;
  ${setCursor("grab")};
  overflow: hidden;
  opacity: 0;
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ justify: "flex-end", align: "flex-end" })};
    cursor: unset;
  }
  &.grabbing {
    ${setCursor("grabbing")};
  }
`;

export const ImageWrapper = styled.div`
  ${setPosition({ position: "absolute", left: "0" })};
  width: 100%;
  height: auto;
  ${preventDrag()};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setPosition({ position: "relative" })};
  }
  ${hiddenmd};
`;

export const DragImageWrapper = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  ${preventDrag()};
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: auto;
  }
`;

export const DragImage = styled.img`
  height: auto;
  width: 100%;
  ${preventDrag()};
`;

export const LogoWrapper = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  padding-top: 5rem;
  ${hiddenmd}
`;

export const Logo = styled.img`
  width: auto;
  max-width: 100px;
`;

export const LoaderTextContainer = styled.div`
  padding: 0 10rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 0;
  }
  ${ipad};
`;

export const LoaderText = styled.h1`
  font-family: "akzidenz-grotesk-bold";
  font-size: 5rem;
  line-height: 5rem;
  margin: 0;
  font-weight: normal;
  color: ${COLOURS.primary.white};
  -webkit-text-stroke: 1px ${COLOURS.primary.black};
  text-transform: uppercase;
`;
